<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 redeem-ggc-products">
                    <img class="product_image" v-bind:src="product_image" v-bind:alt="ggc_product.name"  v-bind:title="ggc_product.name" width="auto" height="196" />
	            	<h1 class="text-center">{{ ggc_product.name }} Redemption</h1>
	            	
                    <div class="card">
                        <div class="card-body">
                            <form id="frm_company_email" action="" enctype="multipart/form-data" method="POST">
                                <table width="100%" class="table">
                                    <tbody>
                                        <input type="hidden" name="_token" v-bind:value="csrf">
                                        <tr v-if="wallet_exist == 0">
                                            <td style="border-top: 0;">
                                                <input class="form-control" type="email" name="email" id="email" value="" placeholder="Your Email" required="" v-bind:value="email" />
                                            </td>
                                        </tr>
                                        <tr v-if="wallet_exist == 0" style="text-align: center;">
                                            <td>
                                                <div style="width: 100%;overflow: hidden;margin: 0 auto 5px;max-width: 303px;position: relative;clear: both;">
                                                    <vue-recaptcha sitekey="6Lf75zEUAAAAAI3SawkXu1GCgLeDaZbfvudKzDMX" :loadRecaptchaScript="true"></vue-recaptcha>
                                                </div>
                                                <button class="btn btn-redeem"> Verify</button>
                                            </td>
                                        </tr>
                                        <tr v-if="not_valid == 1 && recaptcha_is_valid != ''">
                                            <td>
                                                <div class="alert alert-warning text-center" role="alert" style="margin: 0;">
                                                    Your email is invalid 
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="not_valid == 1 && recaptcha_is_valid == ''">
                                            <td style="border: 0;">
                                                <div class="alert alert-warning text-center" role="alert" style="margin: 0;">
                                                    reCAPTCHA is required
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </form>

                            <table id="ggc-plus-container" width="100%" class="table" v-if="wallet_exist == 1"> 

                                <tr>
                                    <td class="hidden-sm-down" style="vertical-align: top;border-top: 0;"><strong>Email:</strong></td>
                                    <td style="vertical-align: top;border-top: 0;">
                                        <label class="hidden-md-up">Email:</label>
                                        <b>{{ this.email }}</b>
                                        <p style="margin: 0;"><a href="javascript:;" @click="changeEmail()">Reset</a></p>
                                        <input type="hidden" name="recipient_email" id="recipient_email" v-bind:value="email" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Credits:</strong></td>
                                    <td>
                                        <label class="hidden-md-up">Credits:</label>
                                        {{ this.wallet_balance | currency('&#8369; ') }} <a style="display: none;" @click="topUpWallet(email)" href="javascript:;" class="btn btn-topup">Topup Credits </a>
                                    </td>
                                </tr>
                                <tr v-if="product_options.length != ''">
                                    <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Product:</strong></td>
                                    <td>
                                        <label class="hidden-md-up">Product:</label>
                                        <select @change="productSelect" style="width: 100%; max-width: 240px; margin: 0;" name="product_id" id="product_id" class="form-control" required="">
                                            <option value="" selected="selected" data-denomination="" data-url="">-- Select --</option>

                                            <option v-for="product in product_options" :key="product.product_id" :value="product.product_id" :data-denominations="product.product_denominations"  :data-url="product.product_url">{{ product.product_name }}</option>

                                        </select>
                                        <div id='product-link' style='margin-top: 5px;'></div>
                                    </td>
                                </tr>
                                <tr v-if="product_options.length != ''">
                                    <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Denomination:</strong></td>
                                    <td>
                                        <label class="hidden-md-up">Denomination:</label>
                                        <select @change="denominationSelect" style="width: 100%; max-width: 240px; margin: 0;" name="product_denomination" id="product_denomination" class="form-control" required="">
                                            <option value="" selected="selected">-- No Product Selected  --</option>
                                            
                                        </select>
                                    </td>
                                </tr>
                                <tr v-if="wallet_balance > 0 && product_options.length != ''">
                                    <td colspan="2" style="text-align: center;">
                                        <button id="redeemBtn" class="btn btn-redeem" @click="redeem()"> <i class="fa fa-gift"></i> Claim</button>
                                    </td>
                                </tr>
                                <tr v-if="wallet_balance <= 0 && wallet_converted > 0">
                                    <td colspan="2" style="text-align: center;">
                                        <div class="alert alert-success text-center" role="alert" style="margin: 0;">
                                            Your credits have been added to your Gifted Wallet
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="wallet_balance <= 0 && wallet_converted == 0">
                                    <td colspan="2" style="text-align: center;">
                                        <div class="alert alert-warning text-center" role="alert" style="margin: 0;">
                                            Insufficient Credits! No more products available for redemption
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="wallet_balance > 0 && product_options.length == ''">
                                    <td colspan="2" style="text-align: center;">
                                        <button class="btn btn-redeem" @click="convertToWallet()" >Add {{ this.wallet_balance | currency('&#8369; ') }} to your Gifted Wallet</button>
                                        <p style="margin: 0;">You will be able to select other brands and top-up the amount once it is added.</p>
                                    </td>
                                </tr>

                                <tr v-if="wallet_balance <= 0 && wallet_converted > 0">
                                    <td colspan="2" style="text-align: center;">
                                        <a target="_blank" class="btn btn-redeem" href="/redeem/ggc-plus">Go to your Gifted Wallet</a>
                                    </td>
                                </tr>


                            </table>

                        </div>


                    </div>
                    <p class="text-center mt-2">Having an issue? Please email us at <a href="mailto:admin@gifted.ph">admin@gifted.ph</a></p>
				</div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .redeem-ggc-products{
        max-width: 420px;
        margin: 0 auto;
        width: 100%;
        text-align: center;
    }
    .redeem-ggc-products .product_image{
        border: 1px solid #ccc;
        border-radius: 5px;
        overflow: hidden;
        margin: 0 auto 15px;
    }
    .redeem-ggc-products h1{
        font-size: 25px;
        margin: 0 auto 15px;
    }
    .redeem-ggc-products table{
        text-align: left;
    }
    .redeem-ggc-products .btn-redeem{
        background-color: #de3c4c;
        color: #fff;
        width: 100%;
        max-width: 300px;
        margin: 5px auto 0;
        padding: 10px;
        font-size: 20px;
    }
    .redeem-ggc-products .btn-redeem:hover{
        background-color: #ad2936;
    }

</style>

<script>
	import moment from 'moment'
    import VueRecaptcha from 'vue-recaptcha'

	export default {
        components: { VueRecaptcha },
        props: ['product', 'ggc'],
        data: () => ({
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            ggc_product: "",
            email: "",
            not_valid: "",
            recaptcha_is_valid: "",
            wallet_exist: "",
            wallet_balance: "",
            wallet_converted: "",
            product_image: "",
            products_available: "",
            product_options: "",
        }), 
        mounted() {

            const product = JSON.parse(this.product);
            this.ggc_product = product;
            console.log(product);

            const ggc = JSON.parse(this.ggc)
            this.email = ggc.email;
            this.not_valid = ggc.not_valid;
            this.recaptcha_is_valid = ggc.recaptcha_is_valid;
            this.wallet_exist = ggc.wallet_exist;
            this.wallet_balance = ggc.wallet_balance;
            this.wallet_converted = ggc.wallet_converted;
            this.product_image = ggc.image;
            this.products_available = ggc.products_available;
            this.product_options = ggc.product_options;

        },
        methods: {
            redeem: function () {

                var productID = $('#product_id').val();
                var denomination = $('#product_denomination').val();
                var email = this.email;

                if(denomination > 0 && productID > 0){

                    Swal.fire({
                        title: 'Are you sure?',
                        showCancelButton: true,
                        confirmButtonText: 'Claim',
                        confirmButtonColor: '#DE3C4C',
                        showLoaderOnConfirm: true,
                        background: '#fff',
                        backdrop: 'rgb(198, 227, 222)',
                        preConfirm: (isConfirm) => {

                            if (!isConfirm) return;

                            return $.ajax({
                                type: "POST",
                                url: "/api/ggc_product/redeem",
                                data: { 'email': email, 'productID': productID, 'denomination': denomination },
                                cache: false,
                            })
                            .then(response => {
                                console.log(response);
                                return response
                            })
                            .catch(error => {
                                Swal.showValidationMessage(
                                  `Request failed! Please contact support.`
                                )
                            })
           
                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                        console.log(result);
                        
                        const new_result = JSON.parse(result.value);
                        console.log(new_result);
                        if (new_result) {
                            Swal.fire({
                              icon: new_result.response.class,
                              title: new_result.response.message,
                              confirmButtonColor: '#DE3C4C',
                              confirmButtonText: 'Close'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    location.reload();
                                }
                            });
                        }
                    });


                }else{
                    Swal.fire({
                      icon: 'error',
                      title: 'No Product Selected or Invalid Denomination',
                      showConfirmButton: false,
                      timer: 2000
                    })
                }

            },
            convertToWallet: function () {

                if(this.wallet_balance > 0){

                    Swal.fire({
                        title: 'Are you sure?',
                        showCancelButton: true,
                        confirmButtonText: 'Convert',
                        confirmButtonColor: '#DE3C4C',
                        showLoaderOnConfirm: true,
                        background: '#fff',
                        backdrop: 'rgb(198, 227, 222)',
                        preConfirm: (isConfirm) => {

                            if (!isConfirm) return;

                            return $.ajax({
                                type: "POST",
                                url: "/api/ggc_product/convert_to_wallet",
                                data: { 'email': this.email },
                                cache: false,
                            })
                            .then(response => {
                                console.log(response);
                                return response
                            })
                            .catch(error => {
                                Swal.showValidationMessage(
                                  `Request failed! Please contact support.`
                                )
                            })
           
                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                        console.log(result);
                        
                        const new_result = JSON.parse(result.value);
                        console.log(new_result);
                        if (new_result) {
                            Swal.fire({
                              icon: new_result.response.class,
                              title: new_result.response.message,
                              confirmButtonColor: '#DE3C4C',
                              confirmButtonText: 'Close'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    location.reload();
                                }
                            });
                        }
                    });


                }else{
                    Swal.fire({
                      icon: 'error',
                      title: 'Credits already converted.',
                      showConfirmButton: false,
                      timer: 2000
                    })
                }
            },
            changeEmail: function () {

                /*
                Swal.fire({
                    title: 'Are you sure to change Email?',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    showLoaderOnConfirm: true,
                    background: '#fff',
                    backdrop: 'rgb(209 73 85 / .9)',
                    preConfirm: (isConfirm) => {
                        if (!isConfirm) return;

                        $('<input type="hidden" name="company_email" id="company_email" value="" />').appendTo('#frm_company_email');
                        $('#frm_company_email').submit();
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                })*/
                $('<input type="hidden" name="company_email" id="company_email" value="" />').appendTo('#frm_company_email');
                $('#frm_company_email').submit();
            },
            productSelect:function(e){
                if (e.target.options.selectedIndex > -1) {
                    const theTarget = e.target.options[e.target.options.selectedIndex].dataset;

                    if(theTarget.url){
                        $( "#product-link" ).html('<a target="_blank" href="https://gifted.ph/'+theTarget.url+'">View Product</a>');
                    }else{
                        $( "#product-link" ).html('');
                    }

                    this.products_denominations = theTarget.denominations;
                    if(this.products_denominations){
                        this.products_denominations = this.products_denominations.split(',');

                        let options = '';
                        this.products_denominations.map((deno) =>{
                            if(deno){
                                options += `<option value="${deno}">${deno}</option>`;
                            }
                        });
                        $('#product_denomination').html(options);
                        console.log(this.products_denominations);
                    }else{
                        $('#product_denomination').html('');
                    }

                
                    /*
                    Swal.fire({
                      icon: 'warning',
                      title: 'Please wait!',
                      html: 'Your voucher is processing...',
                      showConfirmButton: false,
                      timer: 2000,
                      timerProgressBar: true,
                    })
                    */

                    var productID = event.target.value;
                    var denomination = this.products_denominations[0];
                    //alert(denomination);

                    $.ajax({
                        type: "POST",
                        url: "/api/product_merchant_fee",
                        data: {'email': this.company_email, 'productID': productID, 'denomination': denomination},
                        cache: false,
                    })
                    .then(response => {
                        console.log(response);
                        //return response;
                        const result = JSON.parse(response);
                        if(result.response.data > 0){
                            Swal.fire({
                              icon: result.response.class,
                              title: result.response.message,
                              html: '',
                              confirmButtonText: 'Got it!',
                              confirmButtonColor: '#DE3C4C',
                              showLoaderOnConfirm: true,
                            });
                        }
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    });
                     
                }
            },
            denominationSelect:function(e){
                var productID = $('#product_id').val();

                if (productID) {

                    var denomination = event.target.value;
                    //alert(denomination);

                    $.ajax({
                        type: "POST",
                        url: "/api/product_merchant_fee",
                        data: {'email': this.company_email, 'productID': productID, 'denomination': denomination},
                        cache: false,
                    })
                    .then(response => {
                        console.log(response);
                        //return response;
                        const result = JSON.parse(response);
                        if(result.response.data > 0){
                            Swal.fire({
                              icon: result.response.class,
                              title: result.response.message,
                              html: '',
                              confirmButtonText: 'Got it!',
                              confirmButtonColor: '#DE3C4C',
                              showLoaderOnConfirm: true,
                            });
                        }
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    });
                }
            }
        },
        filters: {
          moment: function (date) {
            return moment(date).format('MMMM D, YYYY h:mm:ss A');
          }
        }
    }


</script>